import { render, staticRenderFns } from "./SubDepartmentCreateModal.vue?vue&type=template&id=0db93024&scoped=true"
import script from "./SubDepartmentCreateModal.vue?vue&type=script&lang=js"
export * from "./SubDepartmentCreateModal.vue?vue&type=script&lang=js"
import style0 from "./SubDepartmentCreateModal.vue?vue&type=style&index=0&id=0db93024&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db93024",
  null
  
)

export default component.exports